import React from 'react';
import PropTypes from 'prop-types';
import ImageSetStyles from './imageSetStyles';

const ImageSet = props => {
  return <ImageSetStyles {...props}>{props.children}</ImageSetStyles>;
};

ImageSet.propTypes = {
  children: PropTypes.node,
  itemsInRow: PropTypes.number,
};

ImageSet.defaultProps = {
  children: undefined,
  itemsInRow: 3,
};

const ImageSetItem = props => {
  return <ImageSetStyles.ItemStyles {...props}>{props.children}</ImageSetStyles.ItemStyles>;
};

ImageSetItem.propTypes = {
  children: PropTypes.node.isRequired,
  selected: PropTypes.bool,
  mb: PropTypes.number,
};

ImageSetItem.defaultProps = {
  selected: false,
  mb: 0,
};

ImageSet.Item = ImageSetItem;

export default ImageSet;
